import tacklebox from "tacklebox";

import { Page } from '@/js/Page.js';

function FitAndGap(raw) {
    this.raw = raw;
}
FitAndGap.prototype.getId = function () {
    return this.raw.id;
};
FitAndGap.prototype.getTitle = function () {
    return this.raw.productname;
};
FitAndGap.prototype.getPlanTitle = function () {
    return this.raw.planname;
};
FitAndGap.prototype.getRate = function () {
    return this.raw.rate;
};
FitAndGap.prototype.getRank = function () {
    return this.raw.rank;
};
FitAndGap.prototype.getFee = function () {
    if (this.raw?.fee) {
        return this.raw.fee.toLocaleString();
    }
    return 0;
};
FitAndGap.prototype.getInitialCost = function () {
    if (this.raw?.initialcost) {
        return this.raw.initialcost.toLocaleString();
    }
    return 0;
};
FitAndGap.prototype.getSiteUrl = function () {
    return this.raw.url;
};
FitAndGap.prototype.getEvaluations = function () {
    if (this.raw) {
        return this.raw?.evaluations
    }
    return [];
};
FitAndGap.prototype.getEvaluationById = function (eid) {
    let evs = this.getEvaluations();
    for (let i in evs) {
        for (let j in evs[i].fitandgaps) {
            if (evs[i].fitandgaps[j].id == eid) {
                return evs[i].fitandgaps[j].fitgap;
            }
        }
    }

    for (let i in evs) {
        if (evs[i].id == eid) {
            return evs[i].fitgap;
        }
    
    }
    return "unknown";
};
FitAndGap.prototype.getPayPerUses = function () {
    if (this.raw) {
        return this.raw?.payperuses;
    }
    return [];
};
FitAndGap.prototype.getgetPayPerUseById = function (pid) {
    let ps = this.getPayPerUses();
    for (let i in ps) {
        let p = ps[i];
        if (pid == p.id) {
            return p.fitandgap.fitgap;
        }
    }

    return "unknown";
};
FitAndGap.prototype.getAllFee = function () {
    let fee = 0
    if (this.raw?.fee) {
        try{
            fee = Number(this.raw.fee);
        }catch(ex) {
            tacklebox.e(ex)
        }
    }

    let ppus = this.getPayPerUses();
    for (let i in ppus) {
        let ppu = ppus[i];
        try{
            fee += Number(ppu.fee);
        }catch(ex) {
            tacklebox.e(ex)
        }
    }

    return fee.toLocaleString();
};


function ReportPage() {
    Page.call(this, "lp", "検索受けページ");
    this.interviewId = "";
    this.fitandgaps = [];
    this.showLevel = "high";
    this.isloaded = false;
}
tacklebox.design.extend(ReportPage, Page);
ReportPage.prototype.changeLevel = function (level) {
    this.showLevel = level;
};
ReportPage.prototype.getActives = function () {
    return this.findByLevel(this.showLevel);
};
ReportPage.prototype.findByLevel = function (level) {
    if (level == "all") {
        return this.fitandgaps;
    }
    let hs = [];
    for (let i in this.fitandgaps) {
        if (this.fitandgaps[i].getRank() == level) {
            hs.push(this.fitandgaps[i]);
        }
    }
    return hs;
};
ReportPage.prototype._onInitialize = function () {
    const self = this;

    let rbody = {
        "interview_id": this.interviewId,
    };
    fetch(process.env.VUE_APP_HACHIWARE + "/diagnoses/start", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(rbody)
    })
        .then((response) => response.json())
        .then((json) => {
            for (let i in json.data) {
                self.fitandgaps.push(
                    new FitAndGap(json.data[i])
                );
            }
            self.isloaded = true;
        })
        .catch((error) => {
            tacklebox.e(error);
            self.isloaded = true;
        });

};

export { ReportPage }
